@if (pet) {
  <div class="card-container">
    <div class="header" [ngClass]="{'active': pet.contractStatus === 'active', 'expired' : pet.contractStatus === 'expired', 'future': pet.contractStatus === 'future'}">
      <div class="status-container">
        <div class="status">
          @if (pet.contractStatus === 'active') {
            <p class="tag-12">{{ 'pet-card.status-active-state' | translate }}</p>
          }
          @if (pet.contractStatus === 'expired') {
            <p class="tag-12">{{ 'pet-card.status-expired-state' | translate }}</p>
          }
          @if (pet.contractStatus === 'future') {
            <p class="tag-12">{{ 'pet-card.status-future-state' | translate }}</p>
          }
        </div>
      </div>
      <div class="pet-name">
        <h4><span
          class="wrap">{{ pet.name }}</span><span>s</span><span class="ml-4">{{ 'pet-card.insurance-title' | translate }}</span></h4>
          <!--<h4 class="pet-name-insurance"></h4>-->
        </div>
      </div>
      <div class="card-body">
        <div class="card-vertical-part left">
          <div class="insurance-numbers-container">
            <div class="insurance-number annual-franchise">
              <p class="body-12">{{ 'pet-card.annual-franchise-title' | translate }}</p>
              <p class="subtitle-16">
                {{ pet.annualFranchiseRemaining | currency:'CHF':'symbol':'1.0-0' }} /
                {{ pet.annualFranchiseOverall | number:'1.0-0' }}
              </p>
            </div>
            <div class="insurance-number insured-sum">
              <p class="body-12">{{ 'pet-card.insured-sum-title' | translate }}</p>
              <p class="subtitle-16">
                {{ pet.insuredSumRemaining | currency:'CHF':'symbol':'1.0-0' }} /
                {{ pet.insuredSumOverall | number:'1.0-0' }}
              </p>
            </div>
          </div>
        </div>
        <div class="card-vertical-part right">
          <div class="diagram">
            <svg width="120" height="120" class="diagram-circle" id="diagram-outer">
              <circle cx="60" cy="60" r="56" id="diagram-outer-circle" stroke-width="8" fill="transparent"/>
              <path
                d="M 60 4 A 56 56 0 0 1 60 4"
                #diagramOuterPath
                id="diagram-outer-path"
                stroke="blue"
                stroke-width="8"
                fill="none"
                stroke-linecap="round"
                />
              </svg>
              <svg width="102" height="102" class="diagram-circle" id="diagram-inner">
                <circle cx="51" cy="51" r="47" id="diagram-inner-circle" stroke-width="8" fill="transparent"/>
                <path
                  d="M 51 4 A 47 47 0 0 1 51 4"
                  #diagramInnerPath
                  id="diagram-inner-path"
                  stroke="blue"
                  stroke-width="8"
                  fill="none"
                  stroke-linecap="round"
                  />
                </svg>
                <img class="pet-image" [src]="pet.image" alt="" width="84" height="84"/>
              </div>
            </div>
          </div>
        </div>
      }
      @if (showSubmitButton) {
        <div class="actions">
          <button class="button card-button text-button-small" (click)="actionButtonClick()">
            {{ 'pet-card.button-report-visit' | translate }}
          </button>
        </div>
      } @else {
        <div class="bottom-placeholder"></div>
      }

